import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './resources/i18n.js';
import vuetify from './plugins/vuetify';
import Meta from 'vue-meta'
import VueGtag from "vue-gtag";
import VueScrollactive from 'vue-scrollactive';
import VueAnimateOnScroll from 'vue-animate-onscroll';
import VueAnimate from 'vue-animate-scroll';
import VueShowdown from 'vue-showdown';
import 'animate.css'


Vue.config.productionTip = false

Vue.use(Meta, {
  keyName: 'metaInfo',
  refreshOnceOnNavigation: true
})

Vue.use(VueGtag, {
  config: { id: "UA-22581186-1" }
}, router);


Vue.use(VueScrollactive);
Vue.use(VueAnimateOnScroll);
Vue.use(VueAnimate);
Vue.use(VueShowdown, {
  flavor: 'github',
  options: {
    emoji: true,
  },
})

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


ga('set', 'page', router.currentRoute.path);
ga('send', 'pageview');

router.afterEach(( to, from ) => {
  ga('set', 'page', to.path);
  ga('send', 'pageview');
});
